import {
  SexeLibelle,
  CertificationQualiopiLibelle,
  StatutLibelle,
  StatutHabilitationLibelle,
  TypeEntiteJuridiqueLibelle,
  TypeEntrepriseLibelle,
  TypeNirLibelle,
  TypeUserLibelle,
  NationaliteLibelle,
  TypePublicLibelle,
  ModeFraisNatureLibelle,
  TypeEmployeurPriveLibelle,
  TypeEmployeurPublicLibelle,
} from '@/features/domaine/types/opco'
import { TypePermissionLibelle } from '@/features/domaine/types/opco/Permissions/TypePermission'
import { objectToDropdownItems } from './object'
import { DispositifLibelle } from '@/features/application/shared'

export const dispositifItems = objectToDropdownItems(DispositifLibelle)
export const certificationQualiopiItems = objectToDropdownItems(CertificationQualiopiLibelle)
export const sexeItems = objectToDropdownItems(SexeLibelle)
export const statutItems = objectToDropdownItems(StatutLibelle)
export const typePermissionItems = objectToDropdownItems(TypePermissionLibelle)
export const statutHabilitationItems = objectToDropdownItems(StatutHabilitationLibelle)
export const typeEntiteJuridiqueItems = objectToDropdownItems(TypeEntiteJuridiqueLibelle)
export const typeEntrepriseItems = objectToDropdownItems(TypeEntrepriseLibelle)
export const typeNirItems = objectToDropdownItems(TypeNirLibelle)
export const typeUserItems = objectToDropdownItems(TypeUserLibelle)
export const nationaliteItems = objectToDropdownItems(NationaliteLibelle)
export const typePublicItems = objectToDropdownItems(TypePublicLibelle)
export const modeFraisNatureItems = objectToDropdownItems(ModeFraisNatureLibelle)
export const typeEmployeurPriveItems = objectToDropdownItems(TypeEmployeurPriveLibelle)
export const typeEmployeurPublicItems = objectToDropdownItems(TypeEmployeurPublicLibelle)

